import { Base } from '@studiometa/js-toolkit';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import MapboxCluster from './MapboxCluster.js';

/**
 * Map component
 */
export default class Map extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Map',
    components: {
      MapboxCluster,
    },
    options: {
      zoom: Number,
      center: { type: Array, default: () => [0, 0] },
    },
  };

  /** @type {mapboxgl.Map} */
  map;

  /** @type {boolean} */
  isLoaded = false;

  /**
   * mapboxOptions
   * @returns {object}
   */
  get mapboxOptions() {
    return {
      container: this.$el,
      center: this.$options.center,
      zoom: this.$options.zoom,
      projection: 'mercator',
      pitch: 0,
      style: 'mapbox://styles/agencestudiometa/cmmdn9l7r008i01skcd8ic6ij',
    };
  }

  /**
   * mounted
   */
  mounted() {
    mapboxgl.accessToken =
      'pk.eyJ1IjoiYWdlbmNlc3R1ZGlvbWV0YSIsImEiOiJjbW5yN2pyeGgwMTJhMnRzZDkxdW4ycWI2In0.mUe2OwVoesxcnblu2tXfog';
    this.map = new mapboxgl.Map(this.mapboxOptions);

    this.map.on('load', () => {
      this.isLoaded = true;
      this.$emit('map-load');
    });
  }

  /**
   * destroyed
   */
  destroyed() {
    this.map?.remove();
  }
}
